module.exports = __webpack_public_path__ + "static/media/login_bg.3c6e0687.png";